import styled from 'styled-components/macro';

import Button from 'components/Button/Button';
import FlexContainer from 'components/FlexContainer/FlexContainer';
import Typography from 'components/Typography/Typography';

type TrStyledT = {
  isViewed: boolean;
  isCritical: boolean;
};

export const ListViewStyled = styled.div`
  background-color: ${({ theme }) => theme.colors.white};

  ${({ theme }) => `
    ${theme.devices.tablet} {
      border-radius: ${theme.radius.md};
    }
  `}
`;

export const HeaderStyled = styled(FlexContainer)`
  padding: 0.75rem 0;
  border-bottom: ${({ theme }) => `${theme.borders.sm} ${theme.colors.primary.variant3}`};
  white-space: nowrap;
  overflow-x: auto;

  ${({ theme }) => `
    ${theme.devices.smallDesktop} {
      padding: 1.25rem 0;
    }
  `}
`;

export const ContentStyled = styled.div`
  height: 100%;
  min-height: 30vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  padding: 0.875rem 0 0;
  overflow-x: auto;

  ${({ theme }) => `
    ${theme.devices.smallDesktop} {
      padding: 0.875rem 0 0;
    }
  `}
`;

export const TableStyled = styled.table`
  border-collapse: collapse;
  width: 100%;
  ${({ theme }) => `
    ${theme.devices.desktop} {
      table-layout: auto;
    }
  `}
  tbody tr {
    cursor: pointer;

    &:hover {
      background-color: ${({ theme }) => theme.colors.primary.variant3};
    }

    td {
      ${({ theme }) => `
        ${theme.devices.desktop} {
          padding-top: 14px;
        }

        ${theme.devices.largeDesktop} {
          padding-top: 0;
        }
      `}
    }

    &:first-child {
      td {
        padding-top: 0;
      }
    }
  }

  th,
  td {
    text-align: left;

    &:first-child {
      padding-left: 6px;
      border-radius: ${({ theme }) => `${theme.radius.sm} 0 0 ${theme.radius.sm}`};
      white-space: pre;
    }

    &:last-child {
      width: auto;
      padding-right: 6px;
      border-radius: ${({ theme }) => `0 ${theme.radius.sm} ${theme.radius.sm} 0`};
    }

    &:not(:last-child) {
      padding-right: 4px;

      ${({ theme }) => `
      ${theme.devices.tablet} {
        padding-right: 14px;
      }
  `}
    }
  }

  th {
    padding-bottom: 14px;
    p {
      white-space: nowrap;
    }
  }

  td {
    height: 50px;
  }

  ${({ theme }) => `
    ${theme.devices.mobile} {
      th,
      td {
        &:not(:last-child) {
          padding-right: 16px;
        }
      }
    }
  `}

  ${({ theme }) => `
    ${theme.devices.tablet} {
      td {
        height: 68px;
      }
      th {
        word-break: keep-all;
      }
    }
  `}
`;

export const TrStyled = styled.tr<TrStyledT>`
  background-color: ${({ theme, isViewed }) => (!isViewed ? theme.colors.primary.variant5 : '')};
  text-shadow: ${({ theme, isViewed }) =>
    !isViewed ? `0.3px 0 ${theme.colors.secondary.variant4}` : ''};
  border: ${({ isCritical, theme }) =>
    isCritical ? `solid ${theme.colors.secondary.variant7}` : ''};
`;

export const TitleButtonStyled = styled(Button)`
  display: flex;
  align-items: center;
  padding: 0;
`;

export const TextTitleStyled = styled(Typography)`
  color: ${({ theme }) => theme.colors.primary.variant7};
`;

export const SortingIconsWrapStyled = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 6px;
`;

export const ApprovedStyled = styled.div`
  ${({ theme }) => `
    ${theme.devices.tablet} {
      margin-left: 20px; 
    }
  `}
`;

export const HasAttachmentStyled = styled.div`
  ${({ theme }) => `
    ${theme.devices.tablet} {
      margin-left: 20px; 
    }
  `}
`;

export const BreakWordsContentStyled = styled.div`
  padding: 6px 0;
  ${({ theme }) => `
    ${theme.devices.desktop} {
      word-break:  break-word; 
    }
  `}
`;
